import * as React from "react";
import { useDispatch, useSelector } from "@grandvisionhq/state";
import { Hooks } from "@grandvisionhq/stores-v2";
import { getServiceStore } from "../../../../../../selectors.js";
import { selectServiceStore } from "../../../../../../StepShipping/StepShipping/actions.js";
import { StoreSummary } from "../../../../components/modules/ServiceStore/components/StoreSummary.js";
const StoreSummaryContainer = ({
  globalStoreId,
  actions,
  resetServiceStore,
  className
}) => {
  const dispatch = useDispatch();
  const [getStoreById, storeById] = Hooks.useStoreById();
  const serviceStore = useSelector(getServiceStore);
  React.useEffect(() => {
    if (globalStoreId && serviceStore?.globalStoreId !== globalStoreId) {
      getStoreById({ variables: { globalStoreId } });
    }
  }, [globalStoreId, getStoreById, serviceStore]);
  React.useEffect(() => {
    if (storeById.error) {
      dispatch(selectServiceStore({ serviceStore: null }));
      resetServiceStore && resetServiceStore();
      return;
    }
    if (storeById.data && storeById.data.globalStoreId !== serviceStore?.globalStoreId) {
      const { globalStoreId: globalStoreId2, name, streetName, streetNumber, town } = storeById.data;
      const newServiceStore = {
        globalStoreId: globalStoreId2,
        name,
        streetName,
        streetNumber,
        town
      };
      dispatch(selectServiceStore({ serviceStore: newServiceStore }));
    }
  }, [dispatch, resetServiceStore, serviceStore?.globalStoreId, storeById.data, storeById.error]);
  if (!serviceStore) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    StoreSummary,
    {
      className,
      name: serviceStore.name,
      streetName: serviceStore.streetName,
      streetNumber: serviceStore.streetNumber,
      actions
    }
  );
};
export {
  StoreSummaryContainer
};
//# sourceMappingURL=StoreSummaryContainer.js.map
